/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getImageFromUrl } from './utils';
import { unitToPixels } from 'shared/libs/utils/numbers';
import ImageSelector from './panels/ImageSelector.vue';
import RemoveActiveObject from './panels/RemoveActiveObject.vue';

/**
 * @emits background-change id of the image to use as background
 * @emits close-panel void
 * @emits uploaded the uploaded image
 */
const __vue_script__ = {
    name: 'BackgroundPanel',

    components: {
        ImageSelector,
        RemoveActiveObject,
    },

    props: {
        backgroundId: {
            type: String,
            required: false,
            default: null,
        },
        event: {
            type: Object,
            required: true,
        },
        imageAssets: {
            type: Array,
            required: true,
        },
        pageDimensions: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            canvasSize: [0, 0],
            mismatchedDimensions: false,
            currentImageId: this.backgroundId,
        };
    },

    watch: {
        backgroundId(id) {
            this.currentImageId = id;
        },
        pageDimensions: {
            immediate: true,
            deep: true,
            handler({ width, height, dpi, unit }) {
                this.canvasSize = [
                    Math.ceil(unitToPixels(width, dpi, unit)),
                    Math.ceil(unitToPixels(height, dpi, unit))
                ];

                const asset = this.imageAssets.find(({ _id }) => _id === this.backgroundId);
                if (asset) {
                    this.checkDimensions(asset);
                }
            }
        }
    },

    methods: {
        /** @param {string} backgroundId */
        async onBackgroundChange(backgroundId) {
            const asset = this.imageAssets.find(({ _id }) => _id === backgroundId);
            if (asset && await this.checkDimensions(asset)) {
                this.$emit('background-change', backgroundId);
            }
        },

        /** @param {Record<string,unknown>} assetDoc */
        async checkDimensions(assetDoc) {
            try {
                const [filename] = Object.keys(assetDoc.fp_attachments_s3 || { [assetDoc.file_name]: assetDoc.file_name });
                const url = assetDoc.src ?? this.$utils.assets.getEventAttachmentPath(
                    this.event._id, filename, assetDoc._id,
                );
                const { width, height } = await getImageFromUrl(url);
                const [canvasWidth, canvasHeight] = this.canvasSize;
                const matchesDimensions = canvasWidth === width && canvasHeight === height;
                this.mismatchedDimensions = !matchesDimensions;

                return matchesDimensions;
            } catch (error) {
                console.error('[BackgroundPanel] Could not load image', error);
            }
        },

        onRemoveClick() {
            this.$emit('background-change', undefined);
            this.currentImageId = undefined;
        },
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "side-panel" }, [
    _c("div", { staticClass: "header" }, [
      _c("div", { staticClass: "title" }, [
        _c("i", { staticClass: "icon ic-background-element" }),
        _c("h4", [
          _vm._v(
            _vm._s(
              _vm.$t("onsite_scanning.badge_editor.background_panel_title")
            )
          ),
        ]),
      ]),
      _c("div", { staticClass: "controls" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-icon single btn-primary-alt close",
            on: {
              click: function ($event) {
                return _vm.$emit("close-panel")
              },
            },
          },
          [_c("i", { staticClass: "icon ic-x" })]
        ),
      ]),
    ]),
    _c("div", { staticClass: "note" }, [
      _vm._v(
        _vm._s(_vm.$t("onsite_scanning.badge_editor.add_background_note"))
      ),
    ]),
    _vm.mismatchedDimensions
      ? _c("div", { staticClass: "alert alert-warning" }, [
          _vm._v(
            _vm._s(
              _vm.$t("onsite_scanning.badge_editor.mismatched_dimensions", [
                _vm.canvasSize.at(0) + " x " + _vm.canvasSize.at(1),
              ])
            )
          ),
        ])
      : _vm._e(),
    _c(
      "div",
      { staticClass: "section" },
      [
        _c("image-selector", {
          attrs: {
            event: _vm.event,
            "image-assets": _vm.imageAssets,
            value: _vm.currentImageId,
          },
          on: { input: _vm.onBackgroundChange },
        }),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "section actions" },
      [_c("remove-active-object", { on: { click: _vm.onRemoveClick } })],
      1
    ),
  ])
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/shared/src/ui/components/editors/badge-editor/BackgroundPanel.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__